import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * The "you're about to be signed out" warning shown 60 s before an
 * idle logout. Counting down lets a user who's still there click
 * "Stay signed in" before losing any in-progress work; "Log out now"
 * is the explicit exit.
 */
export function IdleWarningDialog({
  open,
  secondsLeft,
  onStay,
  onLogout,
}: {
  open: boolean;
  secondsLeft: number;
  onStay: () => void;
  onLogout: () => void;
}) {
  return (
    <Dialog open={open} onClose={onStay} aria-labelledby="idle-warning-title">
      <DialogTitle id="idle-warning-title">Still there?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You'll be signed out in {secondsLeft} second
          {secondsLeft === 1 ? '' : 's'} due to inactivity.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          Log out now
        </Button>
        <Button onClick={onStay} variant="contained" autoFocus>
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
